export const environment = {
  production: true,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  //socketUrl: 'http://15.206.88.40/zalon',
  //environment: 'staging',
  //userService: 'http://15.206.88.40/zalon/user-service/api',
  //productService: 'http://15.206.88.40/zalon/product-service/api',
  //orderService: 'http://15.206.88.40/zalon/order-service/api',
  //offerService: 'http://15.206.88.40/zalon/offer-service/api',
  //inventoryService: 'http://15.206.88.40/zalon/inventory-service/api',
  //imageService: 'http://15.206.88.40/zalon/image-service/api',
  //integrationService: 'http://15.206.88.40/zalon/integrations-service/api',
  //customerService: 'http://15.206.88.40/zalon/customer-service/api',
  //posIntegrationService: 'http://15.206.88.40/integrations-service/api',
  //posUserService: 'http://15.206.88.40/user-service/api',
  //posCustomerService: 'http://15.206.88.40/customer-service/api',
  //posOrderService: 'http://15.206.88.40/order-service/api',
  //posOfferService: 'http://15.206.88.40/offer-service/api',
  adminShopId: '640034eaaffe0f0f8964fd22',
  environment: 'production',
  socketUrl: 'https://api.myzalon.com',
  userService: 'https://api.myzalon.com/user-service/api',
  productService: 'https://api.myzalon.com/product-service/api',
  orderService: 'https://api.myzalon.com/order-service/api',
  offerService: 'https://api.myzalon.com/offer-service/api',
  inventoryService: 'https://api.myzalon.com/inventory-service/api',
  imageService: 'https://api.myzalon.com/image-service/api',
  integrationService: 'https://api.myzalon.com/integrations-service/api',
  customerService: 'https://api.myzalon.com/customer-service/api',
  posUserService: 'https://pos-api.myzalon.com/pos/user-service/api',
  posCustomerService: 'https://pos-api.myzalon.com/pos/customer-service/api',
  posIntegrationService: 'https://pos-api.myzalon.com/pos/integrations-service/api',
  posOrderService: 'https://pos-api.myzalon.com/pos/order-service/api',
  posOfferService: 'https://pos-api.myzalon.com/pos/offer-service/api',
};
